import { render, staticRenderFns } from "./HomePageTestimonials.vue?vue&type=template&id=73c2c97c&scoped=true&"
import script from "./HomePageTestimonials.vue?vue&type=script&lang=js&"
export * from "./HomePageTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./HomePageTestimonials.vue?vue&type=style&index=0&id=73c2c97c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2c97c",
  null
  
)

export default component.exports